import React from "react";
import "./FAQPage.css";

const FAQPage: React.FC = () => {
    return (
        <div className="faq-container">
            <h1 className="faq-header">Frequently Asked Questions</h1>
            <div className="faq-content">
                <div className="faq-item">
                    <h3 className="faq-question">1. What is Phase Fitness?</h3>
                    <p className="faq-answer">
                        Phase Fitness is an AI-powered personal trainer app designed to help users stay accountable, motivated, and consistent with their fitness and nutrition goals. The app provides personalized coaching, meal logging, and gamification features to make fitness engaging and effective.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">2. How does the AI personal trainer work?</h3>
                    <p className="faq-answer">
                        The AI trainer in Phase Fitness offers personalized motivation, guidance, and support based on your fitness journey. It adapts to your progress, provides feedback, and helps you stay on track with your goals.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">3. What features does Phase Fitness offer?</h3>
                    <ul className="faq-answer">
                        <li><strong>AI Coaching:</strong> Personalized and engaging fitness and nutrition guidance.</li>
                        <li><strong>Image-Based Meal Logging:</strong> Snap a picture of your meal to track your nutrition easily.</li>
                        <li><strong>Gamification:</strong> Earn XP, unlock achievements, and track your Phase Score.</li>
                        <li><strong>Workout Support:</strong> Receive AI-driven motivation and accountability.</li>
                        <li><strong>Progress Tracking:</strong> Monitor your progress through data-driven insights.</li>
                    </ul>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">4. Who is Phase Fitness for?</h3>
                    <p className="faq-answer">
                        Phase Fitness is designed for busy professionals, gym-goers, and fitness enthusiasts who want an AI-driven coach to help them stay on track with their fitness and nutrition goals.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">5. How is Phase Fitness different from other fitness apps?</h3>
                    <p className="faq-answer">
                        Unlike generic fitness apps, Phase Fitness focuses on motivation, gamification, and AI-driven personalization. Our AI coach adapts to your style and goals, keeping you accountable and engaged.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">6. How does meal logging work?</h3>
                    <p className="faq-answer">
                        Instead of manually entering every food item, you can simply take a picture of your meal. The AI processes the image to help track your intake and provide nutrition insights.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">7. Can I customize my AI coach?</h3>
                    <p className="faq-answer">
                        Currently, the app features one core AI coach optimized for engagement and motivation. Future updates may introduce more customization options.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">8. Is Phase Fitness free to use?</h3>
                    <p className="faq-answer">
                        The app offers a free version with core features. A premium version will be available with additional coaching, insights, and exclusive features.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">9. Where can I download Phase Fitness?</h3>
                    <p className="faq-answer">
                        Phase Fitness is available on the iOS App Store.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">10. How do I get support if I have issues or feedback?</h3>
                    <p className="faq-answer">
                        You can reach out through the app’s support section or contact us at ekene.obiesie@consistencyai.net. We appreciate user feedback to make the app even better!
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">11. Will Phase Fitness add workout tracking?</h3>
                    <p className="faq-answer">
                        While we previously included workout logging, we are currently focusing on AI-driven nutrition tracking and motivation. Workout tracking may return in future updates based on user demand.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">12. What is Phase Pal?</h3>
                    <p className="faq-answer">
                        Phase Pal is a desktop companion for gamers: a 3D animated character that lives on your screen, chats with you, and reacts while you game, grind, or stream. It keeps you company during long queues, solo sessions, and late-night gaming.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">13. Do I need a beast PC to run Phase Pal?</h3>
                    <p className="faq-answer">
                        No. If your PC runs modern games, it can handle Phase Pal. The app is optimized to run smoothly on standard gaming setups.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">14. Can I use Phase Pal offline?</h3>
                    <p className="faq-answer">
                        Yes! Phase Pal has a local mode for offline and private use. No cloud connection required; everything runs on your machine for privacy and performance.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">15. Do I have to be a streamer to use Phase Pal?</h3>
                    <p className="faq-answer">
                        No. Phase Pal is built for anyone who games, studies, or hangs out on PC. While it's great for streamers and VTubers, it's perfect for solo gamers who want company during long sessions.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">16. What customization options does Phase Pal offer?</h3>
                    <p className="faq-answer">
                        Phase Pal offers extensive customization: choose from VRM avatars with expressions and reactions, customize voices (clone your own or pick curated ones), switch between personalities (coach, best friend, gremlin, or create custom personas), and customize on the web before using in-game.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">17. How can streamers use Phase Pal?</h3>
                    <p className="faq-answer">
                        Streamers can use Phase Pal as an on-screen character that reacts while you're live. Customize voices to match your VTuber model, use it as a co-host, lore character, or chaotic gremlin companion. It adds an interactive element to your streams.
                    </p>
                </div>

                <div className="faq-item">
                    <h3 className="faq-question">18. Where can I download Phase Pal?</h3>
                    <p className="faq-answer">
                        Phase Pal is available on Steam. Download it there, then customize your pal on <a href="https://www.phasepal.com" target="_blank" rel="noopener noreferrer">our website</a> before launching.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FAQPage;